import React, { Component, Fragment } from "react";
import League from "./League";
import axios from "axios";
import config from "../config.json";

export default class LeagueAdmin extends Component {
  state = {
    leagues: [],
    campaigns: [],
    teams: [],
    shownLeagues: [],
    updatedCurrentWeek: 0,
    updatedLeagueStart: 0,
    oldCurrentWeek: 0,
    weekAmount: 0,
    amountOfTeamsPerLeague: 4,
    enableSortByOrganization: false,
    automaticMatchups: false,
    loading: false,
  };
  constructor(props) {
    super(props);
    this.handleInputChange = this.handleInputChange.bind(this);
  }

  makeLeaguesAWS = async () => {
    if (window.confirm("Er du sikker?")) {
      const campaignId = document.getElementById("campaigns")?.value;
      const campaign = this.state.campaigns.find((c) => c.id == campaignId);

      const params = {
        input: JSON.stringify({
          campaignId,
          minUsersOnTeam: campaign.minUsersOnTeam,
          amountOfTeamsPerLeague: this.state.amountOfTeamsPerLeague,
          enableSortByOrganization: this.state.enableSortByOrganization,
          weekAmount: campaign.weekAmount,
          nextLeagueStart: campaign.nextLeagueStart,
          timePeriod: campaign.timePeriod,
          automaticMatchups: this.state.automaticMatchups,
        }),
        stateMachineArn:
          "arn:aws:states:eu-north-1:074222540569:stateMachine:Create_Leagues",
      };

      try {
        axios.post(`${config.api.invokeUrl}/leagues/create`, params);
      } catch (err) {
        console.log(err);
      }
      this.setState({ loading: true });
      setTimeout(async () => {
        await this.fetchLeagues();
        this.filterLeagues(document.getElementById("campaigns")?.value);
        this.setState({ loading: false });
      }, 5000);
    }
  };

  fetchCampaignTeams = async (campaignId) => {
    try {
      const res = await axios.get(
        `${config.api.invokeUrl}/campaign/${campaignId}/teams`
      );
      const teams = res.data;

      this.setState({ teams: teams });
    } catch (err) {
      console.log(err);
    }
  };

  getLeagueTeams = (teams, league) => {
    const fetchedTeams = teams.filter((team) => team.league == league.id);
    if (fetchedTeams.length == 0) return league.teams;
    return teams.filter((team) => team.league == league.id);
  };

  fetchLeagues = async () => {
    try {
      const res = await axios.get(`${config.api.invokeUrl}/leagues`);
      const leagues = res.data;

      console.log(res);
      this.setState({ leagues: leagues });
    } catch (err) {
      console.log(err);
    }
  };

  fetchCampaign = async (campaignId) => {
    try {
      const res = await axios.get(
        `${config.api.invokeUrl}/campaign/${campaignId}`
      );
      const currentWeek = res.data.Item.currentWeek;
      const nextLeagueStart = res.data.Item.nextLeagueStart;
      const weekAmount = res.data.Item.weekAmount;
      this.setState({
        currentWeek: currentWeek,
        updatedCurrentWeek: currentWeek,
        oldCurrentWeek: currentWeek,
        nextLeagueStart: nextLeagueStart,
        updatedLeagueStart: nextLeagueStart,
        weekAmount: weekAmount,
      });
    } catch (err) {
      console.log(err);
    }
  };

  fetchCampaigns = async () => {
    try {
      const res = await axios.get(`${config.api.invokeUrl}/campaign/active`);
      const campaigns = res.data;
      this.fetchCampaignTeams(campaigns[0].id);
      this.setState({ campaigns: campaigns });
    } catch (err) {
      console.log(err);
    }
  };

  componentDidMount = async () => {
    await Promise.all([this.fetchCampaigns(), this.fetchLeagues()]);

    await this.fetchCampaign(document.getElementById("campaigns")?.value);
    this.filterLeagues(document.getElementById("campaigns")?.value);
  };

  filterLeagues = (campaignId) => {
    this.setState({
      shownLeagues: this.state.leagues.filter(
        (league) => league.campaignId == campaignId
      ),
    });
  };

  handleUpdateCurrentWeek = async (campaignId, updatedCurrentWeek) => {
    try {
      const params = {
        campaignId,
        currentWeek: parseInt(updatedCurrentWeek),
      };
      await axios.patch(
        `${config.api.invokeUrl}/campaign/${campaignId}/currentweek`,
        params
      );
    } catch (err) {
      console.log(err);
    }
  };

  handleFinalizeMatchups = async (campaignId) => {
    if (window.confirm("Er du sikker?")) {
      axios.get(
        `${config.api.invokeUrl}/campaign/${campaignId}/finalizematchups`
      );
      axios.get(`${config.api.invokeUrl}/campaign/${campaignId}/weeklyreport`);
      axios.get(`${config.api.invokeUrl}/campaign/${campaignId}/setoldranks`);

      this.setState({
        updatedCurrentWeek: parseInt(this.state.updatedCurrentWeek) + 1,
      });
    }
  };

  handleInputChange(event) {
    const target = event.target;
    const value = target.type === "checkbox" ? target.checked : target.value;
    const name = target.name;

    this.setState({
      [name]: value,
    });
  }

  render() {
    return (
      <Fragment>
        <section className="section">
          <h1>Ligaer</h1>
          <div className="control">
            <select
              className="select is-medium"
              name="campaigns"
              id="campaigns"
              onChange={async () => {
                await this.fetchCampaign(
                  document.getElementById("campaigns")?.value
                );
                const select = document.getElementById("campaigns");
                await this.fetchCampaignTeams(
                  select.options[select.selectedIndex].value
                );
                this.filterLeagues(select.options[select.selectedIndex].value);
              }}
            >
              {this.state.campaigns.map((campaign) => {
                return (
                  <option key={campaign.id} value={campaign.id}>
                    {campaign.campaignName}
                  </option>
                );
              })}
            </select>
          </div>
          <h2>Antal ligaer: {this.state.shownLeagues.length}</h2>
          <h2>
            Liga længde: {"  "}
            {this.state.weekAmount}
            {"  "}uger
          </h2>
          <h2>Aktuelle uge: Uge {" " + this.state.currentWeek} </h2>
          <input
            className="mh-small"
            type={"text"}
            name="updatedCurrentWeek"
            onChange={this.handleInputChange}
            value={this.state.updatedCurrentWeek}
          ></input>
          <button
            onClick={() => {
              const select = document.getElementById("campaigns");
              this.handleUpdateCurrentWeek(
                select.options[select.selectedIndex].value,
                this.state.updatedCurrentWeek
              );
            }}
          >
            Sæt aktuel uge
          </button>

          <button
            style={{ margin: 5 }}
            onClick={() => {
              const select = document.getElementById("campaigns");
              this.handleFinalizeMatchups(
                select.options[select.selectedIndex].value
              );
            }}
          >
            SKIFT UGE OG FÆRDIGGØR MATCHUPS
          </button>
          <br />
          <b>Slet og opret ligaer</b>
          <br />
          <input
            className="mh-small"
            type={"text"}
            id="amountOfTeamsPerLeague"
            name="amountOfTeamsPerLeague"
            onChange={this.handleInputChange}
            value={this.state.amountOfTeamsPerLeague}
          />
          <label className="mv-small" htmlFor="amountOfTeamsPerLeague">
            Antal hold pr liga
          </label>
          <br />

          <input
            className="mh-small"
            type={"checkbox"}
            id="enableSortByOrganization"
            name="enableSortByOrganization"
            onChange={this.handleInputChange}
            value={this.state.enableSortByOrganization}
          />
          <label className="mv-small" htmlFor="enableSortByOrganization">
            Sorter efter organisation
          </label>
          <br />

          <input
            className="mh-small"
            type={"checkbox"}
            id="automaticMatchups"
            name="automaticMatchups"
            onChange={this.handleInputChange}
            value={this.state.automaticMatchups}
          />
          <label className="mv-small" htmlFor="automaticMatchups">
            Automatiske matchups
          </label>
          <br />
          <button className="mh-small" onClick={this.makeLeaguesAWS}>
            {this.state.loading ? (
              <div className="spinner"></div>
            ) : (
              "SLET OG OPRET"
            )}
          </button>

          <br />

          <div className="tile is-vertical">
            <div className="tile is-parent flex-wrap">
              {this.state.shownLeagues.map((league, index) => (
                <League
                  league={league}
                  leagueTeams={this.getLeagueTeams(this.state.teams, league)}
                  key={league.id}
                  index={index}
                />
              ))}
            </div>
          </div>
        </section>
      </Fragment>
    );
  }
}
